// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {useDispatch, useSelector, useStore} from 'react-redux';
import type {AppDispatch, AppStore, RootState} from './types';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();
